import { ReactNode } from 'react';
import { lapTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={lapTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
